import React from "react";

const VacuumModel = (props) => {
  return (
    <div className="bg-text accessories-model">
      <div className="container">
        <form>
          <div className="row">
            <div className="col-sm-9">
              <select
                value={props.productSelectedValue}
                onChange={props.ddlproductOnChange}
                className={`form-control search-slt ${props.errors && props.errors.productError ? "invalid-home" : ""}`}
                name="ddlVacuumModel"
              >
                <option key="modelSeriesSelected" value="">
                  Select product Name
                </option>
                {props.productData.length &&
                  props.productData.map((model) => (
                    <option key={model.value} value={model.value}>
                      {model.text}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-sm-3">
              <button
                type="button"
                className="btn btn-lg"
                onClick={props.handleClick}
              >
                Search
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
export default VacuumModel;
